// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tableShadow[data-v-6be08fae] {\n  border-radius: 7.101px;\n  background: #fff;\n  -webkit-box-shadow: 0px 3.55px 15.976px 0px rgba(0, 0, 0, 0.05);\n          box-shadow: 0px 3.55px 15.976px 0px rgba(0, 0, 0, 0.05);\n}", ""]);
// Exports
module.exports = exports;
